import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './reducer';
import { REDUCER_KEY } from './constants';
import { VERIFIED_STATES } from '../../constants/document.constant';

/**
 * Direct selector to the eventTeamDetail state domain
 */

const selectEventTeamDetailDomain = state => state[REDUCER_KEY] || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EventTeamDetail
 */

const makeSelectEventTeamDetail = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate);

const makeSelectTeam = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.team);

const makeSelectTeamName = () =>
  createSelector(selectEventTeamDetailDomain, substate =>
    substate.team ? substate.team.name : '',
  );

const makeSelectTeamId = () =>
  createSelector(selectEventTeamDetailDomain, substate =>
    substate.team ? substate.team.id : '',
  );

const makeSelectTeamRegistrationDate = () =>
  createSelector(selectEventTeamDetailDomain, substate =>
    substate.team ? substate.team.registrationDate : '',
  );

const makeSelectTeamBibNumber = () =>
  createSelector(selectEventTeamDetailDomain, substate =>
    substate.team ? substate.team.bibNumber : '',
  );

const makeSelectLoadingState = () =>
  createSelector(
    selectEventTeamDetailDomain,
    substate => substate.loadingState,
  );

const makeSelectBibState = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.setBibState);

const makeSelectTeamStatusState = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.statusState);

const makeSelectStartTimeState = () =>
  createSelector(
    selectEventTeamDetailDomain,
    substate => substate.startTimeState,
  );

const makeSelectError = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.error);

const makeSelectTeamStatus = () =>
  createSelector(selectEventTeamDetailDomain, substate =>
    substate.team ? substate.team.status : '',
  );

const makeSelectTagState = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.tagState);

const makeSelectUserAssign = () =>
  createSelector(selectEventTeamDetailDomain, substate => substate.userAssign);

const makeSelectWelcomeStatusState = () =>
  createSelector(
    selectEventTeamDetailDomain,
    substate => substate.welcomeStatusState,
  );

const selectGroupAssign = createSelector(
  selectEventTeamDetailDomain,
  substate => substate.groupAssign,
);

export const selectTeamCheckList = createSelector(
  selectEventTeamDetailDomain,
  substate => {
    const { team } = substate;
    let documentCount = 0;
    let approvedDocumentCount = 0;
    const progressMap = new Map();
    const requiredDocumentTypes =
      process.env.REACT_APP_REQUIRED_DOCUMENT_TYPES?.split(',') || [
        'medical_certificate',
        'parental_consent',
        'health_questionnaire',
        'fftri_license',
      ];
    if (!team) {
      return {
        memberCount: 0,
        documentCount,
        approvedDocumentCount,
        startTime: null,
        memberSize: 0,
        raisedPercentage: 0,
        teamId: null,
        group: null,
        eventGroupId: null,
        documents: [],
      };
    }
    const {
      members,
      raisedPercentage,
      startTime,
      id: teamId,
      group,
      event,
    } = team;
    members?.forEach(member => {
      const { documents } = member;
      let docCount = 0;
      let verifiedCount = 0;
      documents?.forEach(({ status, type }) => {
        if (requiredDocumentTypes.indexOf(type) < 0) {
          return;
        }
        docCount += 1;
        if (!progressMap.has(type)) {
          progressMap.set(type, { count: 0, verifiedCount: 0 });
        }
        const entry = progressMap.get(type);
        entry.count += 1;
        if (VERIFIED_STATES.includes(status)) {
          verifiedCount += 1;
          entry.verifiedCount += 1;
        }
      });
      documentCount += docCount;
      approvedDocumentCount += verifiedCount;
    });
    return {
      memberCount: members?.length ?? 0,
      approvedDocumentCount,
      documentCount,
      raisedPercentage,
      startTime,
      teamId,
      group,
      eventGroupId: event?.eventGroup?.id,
      memberSize: event?.memberSize ?? 0,
      documents: Array.from(progressMap.entries()).map(
        ([type, { count, verifiedCount }]) => ({
          type,
          count,
          verifiedCount,
          progress: Math.round((verifiedCount / count) * 100),
        }),
      ),
    };
  },
);

export const selectTeamCoupon = createSelector(
  selectEventTeamDetailDomain,
  substate => {
    const { team } = substate;
    return team?.coupon;
  },
);

export const selectCouponAssignState = createSelector(
  selectEventTeamDetailDomain,
  substate => substate.couponAssign,
);

export default makeSelectEventTeamDetail;
export {
  selectEventTeamDetailDomain,
  makeSelectTeam,
  makeSelectLoadingState,
  makeSelectError,
  makeSelectTeamName,
  makeSelectBibState,
  makeSelectTeamRegistrationDate,
  makeSelectTeamBibNumber,
  makeSelectStartTimeState,
  makeSelectTeamStatus,
  makeSelectTeamId,
  makeSelectTeamStatusState,
  makeSelectTagState,
  makeSelectUserAssign,
  makeSelectWelcomeStatusState,
  selectGroupAssign,
};
